import * as React from 'react'
import { cn } from '@/lib/utils'

interface GlassCardProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Add gold accent border on top */
  accent?: boolean
  /** Hover effect with glow */
  hover?: boolean
}

const GlassCard = React.forwardRef<HTMLDivElement, GlassCardProps>(
  ({ className, accent = false, hover = false, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn('glass-card rounded-xl p-6 md:p-8', accent && 'gold-accent', hover && '', className)}
        {...props}
      >
        {children}
      </div>
    )
  }
)

GlassCard.displayName = 'GlassCard'

export { GlassCard }
